/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function ($) {
  // Move product title sku on a new line
  // $('.js-product-title').each(function (i, elem) {
  //   var $productTitle = $(elem);
  //   var productTitle = $productTitle.text();
  //   var regex = /(#.*)$/;
  //   var regexExec = regex.exec(productTitle);

  //   if (regexExec !== null) {
  //     var title = productTitle.substring(0, regexExec.index);
  //     var sku = regexExec[0];
  //     var newTitle = title + '<br>' + sku;

  //     $productTitle.html(newTitle);
  //   }
  // });

  // Scroll to top button
  var $scrollTopBtn = $('.js-scroll-top');
  $(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
      $scrollTopBtn.addClass('is-visible');
    } else {
      $scrollTopBtn.removeClass('is-visible');
    }
  });

  $scrollTopBtn.on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({ scrollTop: 0 }, 300);
  });

  setTimeout(function () {
    $('.PageLoader').hide();
  }, 1000);

  $('body').on('click', '.js-scroll-to-view', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var targetSelector = this.hash;
    var $target = $(targetSelector);

    $('html, body').animate(
      {
        scrollTop: $target.offset().top - 90
      },
      {
        duration: 800,
        step: function (now, fx) {
          var newOffset = $target.offset().top;

          if (fx.end !== newOffset) {
            fx.end = newOffset - 90;
          }
        }
      }
    );
  });

  $('html, body').scrollTop(0);

  var $mediaTitlesCarousel = jQuery('.js-media-titles-carousel');

  if ($mediaTitlesCarousel && $mediaTitlesCarousel.length) {
    jQuery('.js-media-titles-carousel').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false,
      autoplay: false,
      nextArrow: $('.js-media-titles-carousel__next-arrow'),
      prevArrow: $('.js-media-titles-carousel__prev-arrow'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }

  // $('.js-add-product-to-cart').on('click', function(e) {
  //   e.preventDefault();

  //   var $this = $(this);

  //   $this.attr('disabled', true);

  //   document.dispatchEvent(new CustomEvent('theme:loading:start'));

  //   var id = $this.data('id');

  //   fetch('/cart/add.js', {
  //     body: JSON.stringify({
  //       form_type: 'product',
  //       id: String(id),
  //       quantity: '1',
  //       utf8: "✓"
  //     }),
  //     credentials: 'same-origin',
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  //     }
  //   }).then(function (response) {
  //     document.dispatchEvent(new CustomEvent('theme:loading:end'));
  //     $this.attr('disabled', false);

  //     if (response.ok) {
  //       // We simply trigger an event so the mini-cart can re-render
  //       document.dispatchEvent(new CustomEvent('product:added', {
  //         bubbles: true,
  //         detail: {
  //           variant: id,
  //           quantity: '1'
  //         }
  //       }));
  //     } else {
  //       response.json().then(function (content) {
  //         var errorMessageElement = document.createElement('span');
  //         errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
  //         errorMessageElement.innerHTML = content['description'];

  //         var $errMsg = $(errorMessageElement);
  //         $errMsg.insertAfter($this);

  //         setTimeout(function () {
  //           $errMsg.remove();
  //         }, 6000);
  //       });
  //     }
  //   });
  // });
	
	
	//Global function top open / close lightboxes
    var PDMLightbox = (function () {

        var $body = $('body');
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $body.on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target]', function (e) {

            e.preventDefault();

            var classes = $(this).data('lightbox-classes');
            var iframe = $(this).data('lightbox-iframe');
            var blur = $(this).data('lightbox-blur');

            if (iframe) {

                var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
                var vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;

                if (youtubePattern.test(iframe)) {

                    classes += ' youtube-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(youtubePattern, replacement);

                }

                if (vimeoPattern.test(iframe)) {

                    classes += ' vimeo-vid'

                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';

                    iframe = iframe.replace(vimeoPattern, replacement);

                }

                $lightbox_content.html('<div class="iframe-wrap">' + iframe + '</div>');

            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                }
                $lightbox_content.html(content);
            }

            if (blur != false) {
                $body.addClass('blur');
            }

            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            setTimeout(function () {
                $body.removeClass('blur');
            }, 250);
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());
	
	var giftModal = (function(){
		
		var $modal = $('.gift-modal'),
			$steps = $modal.find('.gift-modal__step'),
			$alToggle = $modal.find('.note-alignment-toggle'),
			alignment = 'left',
			$cartNote = $('#cart-note'),
			$note = $modal.find('.Form__Textarea'),
			$nav = $modal.find('.gift-modal__nav'),
			$notePreview = $modal.find('.opened-note__section--bottom');
		
		if( $cartNote.val() != '' ){
			$('.gift-message-box').show();
			$('.gift-modal-toggle').text('Remove Gift Message');
		}else{
			$('.gift-modal-toggle').text('Add Gift Message');
		}
		
		function resetNotePopup($clear){
			
			if( $clear == true ){
				$cartNote.val('');
				$('.gift-modal-toggle').text('Add Gift Message');
				$('.gift-message-box').hide();
			}
			
			$steps.removeClass('active');
			$steps.first().addClass('active');
			$('.gift-modal__nav--prev').removeClass('active');
			$('.gift-modal__nav--submit').removeClass('active');
			$('.gift-modal__nav--next').addClass('active');
			
		}
		
		$('body').on('click','.gift-modal-toggle',function(){
			
			$clear = false;
			
			if( $('.gift-modal-toggle').text() == 'Remove Gift Message' ){
				$clear = true;
				resetNotePopup($clear);
			}else{
				resetNotePopup($clear);
				$('[data-action="close-drawer"]').trigger('click');
				var value = $cartNote.val();
				if( value != '' && value != undefined ){
					console.log(value);
					value = value.split(/\n+/g);
					value.shift();
					$note.val(value.join("\n"));
				}
				$modal.addClass('active');
			}
			
		});
		
//		$alToggle.click(function(){
//		
//			if( alignment ==  'left' ){
//				alignment = 'center';
//			}else{
//				alignment = 'left';
//			}
//			
//			$note.css({'text-align':alignment});
//			$notePreview.css({'justify-content':alignment});
//			
//		});
		
		$nav.click(function(){
			
			var $this = $(this),
				currentStep = $steps.siblings('.active').data('step'),
				maxStep = $steps.length,
				nextStep;
			
			if( $this.hasClass('gift-modal__nav--submit') ){
				
				var isChecked = $modal.find('#approved').is(':checked');
				
				if( isChecked ){
					
					$('.validation-error.terms-error').hide();
					$modal.removeClass('active');
					$('.Cart__Note.Form__Textarea').val($note.val());
					$('.gift-message-box').show();
					$('.gift-modal-toggle').text('Remove Gift Message');
					$('.open-draw-cart').trigger('click');
					
				}else{
					
					$('[data-action="close-drawer"]').trigger('click');
					$('.validation-error.terms-error').show();
					
				}
				
			}else{
				
				if( $note.val() == '' ){
					$('.validation-error.note-error').show();
					return;
				}else{
					$('.validation-error.note-error').hide();
				}
				
				if( $this.hasClass('gift-modal__nav--next') ){
					nextStep = currentStep + 1;
				}else {
					nextStep = currentStep - 1;
				}

				if( nextStep < 1 ){ nextStep = 1; }


				if( nextStep > 1 ){
					$modal.find('.gift-modal__nav--prev').addClass('active');
				}else{
					$modal.find('.gift-modal__nav--prev').removeClass('active');
				}

				if( nextStep == maxStep ){
					$modal.find('.gift-modal__nav--next').removeClass('active');
					$modal.find('.gift-modal__nav--submit').addClass('active');
				}else{
					$modal.find('.gift-modal__nav--next').addClass('active');
					$modal.find('.gift-modal__nav--submit').removeClass('active');
				}

				$notePreview.text($note.val());

				if( $steps.siblings('[data-step="'+nextStep+'"]').length ){

					$('.o-product-personalize__preview').show();
					$('.opened-note').hide();
					
					if( nextStep == 2 ){
						setTimeout(function(){
							$('.o-product-personalize__preview').fadeOut(function(){
								$('.opened-note').fadeIn();
							});
						},1000);
					}

					$steps.removeClass('active');
					$steps.siblings('[data-step="'+nextStep+'"]').addClass('active');

				}
				
			}
			
		});
		
	}());
	
});
